<template>
  <div class="external-share">
    <nav-control-panel scenario='external-share'/>
    <share-link
      :external="true"
      :uniqueName="$route.params.unique_name"
      :isHeaderFold="isHeaderFold"
      @trigger-fold="triggerFold"
    />
  </div>
</template>
<script>
import ShareLink from './ShareLink'
import NavControlPanel from './NavControlPanel'
import config from '@/config'
import { i18n } from '@/utils/i18n'
import { setDocumentTitle } from '@/utils/common'

export default {
  name: 'ExternalShareLink',
  components: {
    NavControlPanel,
    ShareLink
  },
  data () {
    return {
      isHeaderFold: true
    }
  },
  mounted () {
    let title
    if (config.enterprise_info && config.enterprise_info.customized_share_link_page_title) {
      title = config.enterprise_info.customized_share_link_page_title
    } else {
      title = i18n.t('share.view') + ' - ' + config.product_name
    }
    setDocumentTitle(title)
  },
  methods: {
    triggerFold (fold) {
      this.isHeaderFold = !this.isHeaderFold
    }
  }
}
</script>
<style lang="postcss">
.external-share {
  display: flex;
  flex-direction: column;
  height: 100%;

  & .control-panel {
    flex: 0 0 auto
  }

  & .share-link {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  }

  & .share-main,
  & .share-content,
  & .preview-main,
  & .file-view,
  & .PSPDFKit-Container,
  & .video-js {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    height: 100%;
    overflow: auto;
  }

  & .preview-body {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow: hidden;
  }

  & .preview-body > .preview-viewer {
    overflow: auto;
  }
}
</style>
